import React, { useEffect, useState } from 'react';
import S from './CompanyManagement.module.scss';
import { AdminCompanyInfoType } from '../../../types/AdminTypes';
import { fetchAdminCompanyList, fetchAdminUsers } from '../../../repository/AdminRepository';
import CompanyEditor from '../CompanyEditor';
import _ from "lodash";
import {InputUtils} from "../../../utils/InputUtils";

const CompanyManagement = () => {
  const ADMIN_TOKEN = process.env.REACT_APP_IVY_ADMIN_TOKEN || '';
  const [companyList, setCompanyList] = useState<AdminCompanyInfoType[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);

  const [showCompanyEditor, setShowCompanyEditor] = useState<boolean>(false);
  const [clickedCompanyEditorId, setClickedCompanyEditorId] = useState<number>(0);
  const [editorMode, setEditorMode] = useState<'register' | 'editor'>('editor');

  const maxPageButtons = 10;
  const currentPageGroup = Math.floor(currentPage / maxPageButtons);
  const startPage = currentPageGroup * maxPageButtons;
  const endPage = Math.min(startPage + maxPageButtons, totalPages);
  const pages = Array.from({ length: endPage - startPage }, (_, index) => startPage + index);

  const getAdminCompanyList = (title: string, page: number, size: number, token: string) => {
    fetchAdminCompanyList(title, page, size, token)
      .then((res) => {
        setCompanyList(res.content);
        setTotalElements(res.totalElements);
        setTotalPages(res.totalPages);
      })
      .catch((e) => console.error(e));
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getAdminCompanyList(searchTerm, page, 10, ADMIN_TOKEN);
  };
  const handleSearch = (e: any) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    getAdminCompanyList(searchTerm,0, 10, ADMIN_TOKEN);
  }, [showCompanyEditor]);

  if (showCompanyEditor) {
    if (editorMode === 'register') {
      return <CompanyEditor mode={editorMode} setShowCompanyEditor={setShowCompanyEditor} />;
    } else {
      return <CompanyEditor mode={editorMode} id={clickedCompanyEditorId} setShowCompanyEditor={setShowCompanyEditor} />;
    }
  }

  return (
    <>
      <div className={S.admin_page}>
        <h1>기업 관리</h1>
        <div className={S.search_container}>
          <input
            className={S.search_name}
            type="text"
            placeholder="이름 검색"
            value={searchTerm}
            onChange={handleSearch}
          />
          <div className={S.empty}></div>
          <button className={S.search_btn} onClick={() => {
            setCurrentPage(0);
            getAdminCompanyList(searchTerm, 0, 10, ADMIN_TOKEN);
          }}>검색</button>
          <div className={S.empty}></div>
          <button
            className={S.search_btn}
            onClick={() => {
              setEditorMode('register');
              setShowCompanyEditor(true);
            }}
          >
            기업 등록
          </button>
          <p className={S.total}>전체 기업 수 {InputUtils.numberWithCommas(totalElements)}</p>
        </div>
        <table>
          <thead>
            <tr>
              <th>순번</th>
              <th>회사명</th>
              <th>회사 노출명</th>
              <th>사업자 번호</th>
              <th>업종</th>
              <th>설명</th>
              <th>필터 사용여부</th>
            </tr>
          </thead>
          <tbody>
            {companyList?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1 + currentPage * 10}</td>
                <td
                  onClick={() => {
                    setClickedCompanyEditorId(item.id);
                    setEditorMode('editor');
                    setShowCompanyEditor(true);
                  }}
                >
                  {item.name}
                </td>
                <td>{item.displayName}</td>
                <td>{item.businessNo}</td>
                <td>{item.industry}</td>
                <td>{item.description}</td>
                <td>{item.usedFilter? 'O' : 'X'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className={S.div_vertical_blank}></div>
        <div className={S.pagination}>
          {currentPageGroup > 0 && (
            <button onClick={() => handlePageChange(startPage - 1)} className={S.page_button}>
              &lt; 10개
            </button>
          )}
          {pages.map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={currentPage === page ? S.selected_button : S.page_button}
            >
              {page + 1}
            </button>
          ))}
          {currentPageGroup < Math.ceil(totalPages / maxPageButtons) - 1 && (
            <button onClick={() => handlePageChange(endPage)} className={S.page_button}>
              10개 &gt;
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default CompanyManagement;
